var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockAlt = function SvgLockAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2,6 L2,11 L10,11 L10,6 L2,6 Z M3,5 L3,3 C3,1.34314575 4.34314575,4.4408921e-16 6,0 C7.65685425,-4.4408921e-16 9,1.34314575 9,3 L9,5 L11,5 L11,12 L1,12 L1,5 L3,5 Z M4,5 L8,5 L8,3 C8,1.8954305 7.1045695,1 6,1 C4.8954305,1 4,1.8954305 4,3 L4,5 Z"
  })));
};
export default SvgLockAlt;